import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Row, Typography } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import { LinkIcon } from 'seagull/icons/essentials';
import styles from './BrandHeader.module.scss';
export const BrandHeader = (param)=>{
    let { claudeLabel } = param;
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 3,
        alignItems: "center",
        justifyContent: "center",
        className: styles.brandHeader,
        children: [
            /*#__PURE__*/ _jsx(Box, {
                className: styles.logoWrapper,
                children: /*#__PURE__*/ _jsx(AnchorLogo, {
                    className: styles.anchorLogo
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                className: styles.connector,
                children: /*#__PURE__*/ _jsx(LinkIcon, {
                    size: 18
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                className: styles.claudeMark,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    weight: "bold",
                    children: claudeLabel
                })
            })
        ]
    });
};
